// @ts-nocheck

// Product Routes
const ProductsView = () => import("../views/admin/Product/ListView.vue");
const ProductCreateView = () => import("../views/admin/Product/CreateView.vue");
const ProductEditView = () => import("../views/admin/Product/EditView.vue");

// Project Routes
const ProjectsView = () => import("../views/admin/Project/ListView.vue");
const ProjectCreateView = () => import("../views/admin/Project/CreateView.vue");
const ProjectEditView = () => import("../views/admin/Project/EditView.vue");
const PointCreateView = () => import("../views/admin/Project/CreatePointView.vue");

// Customer Routes
const CustomersView = () => import("../views/admin/Customers/ListView.vue");
const CustomerCreateView = () => import("../views/admin/Customers/CreateView.vue");
const CustomerEditView = () => import("../views/admin/Customers/EditView.vue");

// Customer Boards
const CustomerBoardsView = () => import("../views/admin/Board/ListView.vue");
const CustomerBoardsCreateView = () => import("../views/admin/Board/CreateView.vue");
const CustomerBoardsEditView = () => import("../views/admin/Board/EditView.vue");

// Rights Profiles
const RightsProfilesListView = () => import("../views/admin/Profiles/ListView.vue");

// Admin Routes
const ConfigListView = () => import("../views/admin/Config/ListView.vue");
const ConfigCreateView = () => import("../views/admin/Config/CreateView.vue");
const ConfigTableView = () => import("../views/admin/Config/TabView.vue");
const ConfigCloudCreateView = () => import("../views/admin/Config/Clouds/CreateView.vue");
const ConfigCloudEditView = () => import("../views/admin/Config/Clouds/EditView.vue");
const ConfigEditView = () => import("../views/admin/Config/EditView.vue");
// Logs Routes
const LogsView = () => import("../views/admin/LogsView.vue");

// Payment Method
const PaymentMethods = () => import("../views/admin/PaymentMethod.vue");

// Teams
const TeamsListView = () => import("../views/admin/Teams/ListView.vue");
const TeamCreateView = () => import("../views/admin/Teams/CreateView.vue");
const TeamEditView = () => import("../views/admin/Teams/EditView.vue")

// Interfaces
interface IMetaObject {
  layout?: string;
  is_auth_protected?: boolean;
  only_admin?: boolean;
}

interface IRoute {
  path: string;
  name: string;
  component: object;
  meta: IMetaObject;
}

// Routes
const routes: Array<IRoute> = [
  // Admin Routes
  {
    path: "/admin",
    name: "AdminPage",
    component: ProductsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/server_logs",
    name: "AdminLogsView",
    component: LogsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/rights-profiles",
    name: "AdminRightsProfiles",
    component: RightsProfilesListView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/boards",
    name: "AdminCustomerBoards",
    component: CustomerBoardsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/boards/create",
    name: "CustomerBoardsCreateView",
    component: CustomerBoardsCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/boards/edit/:id",
    name: "CustomerBoardsEditView",
    component: CustomerBoardsEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },

  {
    path: "/admin/configs/add",
    name: "AdminManageAddConfigs",
    component: ConfigCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/configs/edit/:id",
    name: "AdminManageEditConfigs",
    component: ConfigEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/configs/:tab",
    name: "AdminManageTableConfigs",
    component: ConfigTableView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    }
  },
  {
    path: '/admin/configs/clouds/create',
    name: 'AdminManageAddCloudConfigs',
    component: ConfigCloudCreateView,
    meta: {
      layout: 'LayoutAdmin',
      protected: true,
      only_admin: true
    }
  },
  {
    path: '/admin/configs/clouds/edit/:id',
    name: 'AdminManageEditCloudConfigs',
    component: ConfigCloudEditView,
    meta: {
      layout: 'LayoutAdmin',
      protected: true,  
      only_admin: true
    }
  },
  {
    path: "/admin/credit-cards",
    name: "AdminCreditCardsPage",
    component: PaymentMethods,
    meta: {
      layout: "LayoutAdmin",
      is_auth_protected: true,
      only_admin: true,
    },
  },

  // Product Routes
  {
    path: "/admin/products",
    name: "AdminManageProducts",
    component: ProductsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/products/create",
    name: "AdminManageProductsCreate",
    component: ProductCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/products/edit/:id",
    name: "AdminManageProductsEdit",
    component: ProductEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },

  // Project Routes
  {
    path: "/admin/projects",
    name: "AdminManageProjects",
    component: ProjectsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/projects/create",
    name: "AdminManageProjectsCreate",
    component: ProjectCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/projects/edit/:id",
    name: "AdminManageProjectsEdit",
    component: ProjectEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/project/:id/point",
    name: "AdminManagePointsCreate",
    component: PointCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },

  // Customer Routes
  {
    path: "/admin/customers",
    name: "AdminManageCustomers",
    component: CustomersView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/customers/create",
    name: "AdminManageCustomersCreate",
    component: CustomerCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/customers/edit/:id",
    name: "AdminManageCustomersEdit",
    component: CustomerEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },

  // Boards Routes
  {
    path: "/admin/boards",
    name: "AdminCustomerBoards",
    component: CustomerBoardsView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/boards/create",
    name: "CustomerBoardsCreateView",
    component: CustomerBoardsCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/boards/edit/:id",
    name: "CustomerBoardsEditView",
    component: CustomerBoardsEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },

  // Teams Routes
  {
    path: "/admin/teams",
    name: "AdminCustomerTeams",
    component: TeamsListView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/teams/create",
    name: "AdminCustomerTeamsCreate",
    component: TeamCreateView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
  {
    path: "/admin/teams/edit/:id",
    name: "AdminCustomerTeamsEdit",
    component: TeamEditView,
    meta: {
      layout: "LayoutAdmin",
      protected: true,
      only_admin: true,
    },
  },
];

export default routes;